import { styled } from '@mui/material/styles';

export const FooterContainer = styled('div')(({ theme }) => ({
  position: 'sticky',
  top: 'calc(100vh - 64px)',
  paddingBottom: theme.spacing(3),
}));

export const FooterContent = styled('div')(({ theme }) => ({
  maxWidth: '1000px',
  margin: theme.spacing(0, 'auto'),
  paddingTop: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
  },
}));

export const FooterLinks = styled('ul')(({ theme }) => ({
  paddingLeft: 0,
  listStyle: 'none',
  display: 'flex',
  gap: theme.spacing(3),
  alignItems: 'center',

  [theme.breakpoints.down('md')]: {
    marginBottom: theme.spacing(1),
    flexDirection: 'column',
    alignItems: 'center',
  },
}));
